<template>
  <div class="confirm-overlay">
    <div class="confirm-box">
      <!-- Header -->
      <div class="confirm-header">
        <h3>Confirm Activate Promotion</h3>
      </div>

      <!-- Message -->
      <div class="confirm-body">
        <p>Please confirm activation and adjust start/end dates if needed.</p>

        <!-- Start Date -->
        <div class="form-group">
          <label for="start-date">Start Date</label>
          <input
              type="date"
              id="start-date"
              v-model="startDate"
          />
        </div>

        <!-- End Date -->
        <div class="form-group">
          <label for="end-date">End Date</label>
          <input
              type="date"
              id="end-date"
              v-model="endDate"
          />
        </div>
      </div>

      <!-- Actions -->
      <div class="confirm-actions">
        <button class="yes-btn" @click="promotionActivate">
          <span v-if="loading">
            <span class="spinner"></span>
          </span>
          <span v-else>
            Yes
          </span>
        </button>
        <button class="no-btn" @click="closeDialog">No</button>
      </div>
    </div>
  </div>
</template>

<script>
import { activePromotion } from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  props: {
    promoId: { type: String, required: true },
    start_date: { type: String, required: true },
    end_date: { type: String, required: true }
  },

  data() {
    return {
      token: localStorage.getItem('token_set'), //Get the API access token from the local storage
      startDate: this.start_date,
      endDate: this.end_date,
      loading: false,
    }
  },

  setup() {
    const toast = useToast();
    return { toast };
  },

  methods: {
    //Close Confirm Dialog
    closeDialog() {
      this.$emit("close");
    },

    //Handle Activate Promotion
    async promotionActivate() {
      try {
        //Set Loading Status
        this.loading = true;

        //Build payload
        let payload = {};
        payload = {
          "status": 1,  //1=active, 3=deactivate
          "start_date": this.startDate,
          "end_date": this.endDate
        }

        //Call API for activate promotion
        const response = await activePromotion(this.promoId, this.token, payload);

        if (response.data.status === 'success') {
          this.toast.success(response.data.message);

          // Close the modal/sheet
          this.closeDialog();

          // Emit redirect event for parent component to handle redirection
          this.$emit("redirect");
        } else {
          this.toast.error(response.data.message);
        }
      } catch (e) {
        this.toast.error("Failed to activate this promotion.");
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
/* Overlay */
.confirm-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex; justify-content: center; align-items: center;
  z-index: 2000;
}

/* Confirm box */
.confirm-box {
  background: #fff;
  padding: 20px;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
}

/* Header Title */
.confirm-header h3 {
  margin: 0;
  font-size: 18px;
}

/* Body */
.confirm-body {
  margin: 15px 0;
  font-size: 15px;
  color: #333;
}

/* Promotion Validity Date Range Extend Form */
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}

/* Promotion Validity Date Range Extend Form - Label */
.form-group label {
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 14px;
}

/* Promotion Validity Date Range Extend Form - Input */
.form-group input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Actions */
.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Actions - Yes Button */
.yes-btn {
  background: #28a745;
  color: #fff;
  padding: 6px 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

/* Actions - No Button */
.no-btn {
  background: #dc3545;
  color: #fff;
  padding: 6px 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

/* Circular Progress Indicator Styles */
.spinner {
  border: 3px solid #f3f3f3; /* Light gray */
  border-top: 3px solid #28a745; /* Blue */
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}

/* Circular Progress Indicator Styles - Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
